import React, {Component} from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";

// material-ui components
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-dashboard-pro-react/components/navPillsStyle.js";

const useStyles = makeStyles(styles);


class NavPills extends Component {
  state={
    active: 0
  }
  componentDidMount() {
    if(this.props.active){
      this.setState({active: this.props.active})
    }
  }
  handleChange = (event, active) => {
    if(this.props.tabs[active].onClick){
      this.props.tabs[active].onClick();
      return
    }
    this.setState({active});
  };
  handleChangeIndex = index => {
    this.setState({active: index});
  };

  render() {
    const { tabs, direction, color, horizontal, alignCenter, classes } = this.props;
    const { active } = this.state
    const flexContainerClasses = classNames({
      [classes.flexContainer]: true,
      [classes.horizontalDisplay]: horizontal !== undefined
    });
    const tabButtons = (
      <Tabs
        classes={{
          root: classes.root,
          fixed: classes.fixed,
          flexContainer: flexContainerClasses,
          indicator: classes.displayNone
        }}
        value={active}
        onChange={this.handleChange}
        centered={alignCenter}
      >
        {tabs.map((prop, key) => {
          var icon = {};
          if (prop.tabIcon !== undefined) {
            icon["icon"] = <prop.tabIcon className={classes.tabIcon} />;
          }
          const pillsClasses = classNames({
            [classes.pills]: true,
            [classes.horizontalPills]: horizontal !== undefined,
            [classes.pillsWithIcons]: prop.tabIcon !== undefined
          });
          return (
            <Tab
              label={prop.tabButton}
              key={key}
              {...icon}
              // disableFocusRipple
              disableRipple
              classes={prop.styleOverride? {}:{
                root: pillsClasses,
                selected: classes[color]
              }}
              style={prop.styleOverride?prop.styleOverride:{}}
            />
          );
        })}
      </Tabs>
    );
    let tabContent = (
      <div className={classes.contentWrapper}>
        <SwipeableViews
          axis={direction === "rtl" ? "x-reverse" : "x"}
          index={active}
          onChangeIndex={this.handleChangeIndex}
          style={{ overflowY: "hidden" }}
        >
          {/* Every tab gets a slide, including action-only pills with no
              tabContent, so slide indexes stay aligned with tab indexes and
              SwipeableViews is never handed a null child. */}
          {tabs.map((prop, key) => (
            <div className={classes.tabContent} key={key}>
              {key===active && prop.tabContent}
            </div>
          ))}
        </SwipeableViews>
      </div>
    );
    return horizontal !== undefined ? (
      <GridContainer>
        <GridItem {...horizontal.tabsGrid}>{tabButtons}</GridItem>
        <GridItem {...horizontal.contentGrid}>{tabContent}</GridItem>
      </GridContainer>
    ) : (
      <div>
        {tabButtons}
        {tabContent}
      </div>
    );
  }
}


NavPills.defaultProps = {
  active: 0,
  color: "primary"
};

NavPills.propTypes = {
  // index of the default active pill
  active: PropTypes.number,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      // Usually a label, but action pills pass a rendered button.
      tabButton: PropTypes.node,
      tabIcon: PropTypes.object,
      tabContent: PropTypes.node,
      styleOverride: PropTypes.object,
    })
  ).isRequired,
  color: PropTypes.oneOf([
    "primary",
    "warning",
    "danger",
    "success",
    "info",
    "rose"
  ]),
  direction: PropTypes.string,
  horizontal: PropTypes.shape({
    tabsGrid: PropTypes.object,
    contentGrid: PropTypes.object
  }),
  alignCenter: PropTypes.bool,
};
export default withStyles(styles)(NavPills)

